import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Studenter = lazy(() => import("@/pages/elavtal/Studenter"));

export const Route = createFileRoute("/elavtal/student")({
  head: () => seoHead("/elavtal/student"),
  component: () => <Studenter />,
});
